/* Storefront taxonomy helpers: audiences (Women / Men / Kids) × departments (Clothing / Shoes / Bags & Accessories). */
export const AUDIENCES = ["women", "men", "kids"];
export const DEPARTMENTS = ["clothing", "shoes", "bags-accessories"];

export const isAudience = (a) => AUDIENCES.includes(a);
export const audiencePath = (a) => `/${a}`;
export const deptPath = (dept, audience) => (audience && isAudience(audience) ? `/${audience}/${dept}` : `/${dept}`);
export const catPath = (dept, cat, audience) => `${deptPath(dept, audience)}/${cat}`;
export const brandPath = (slug) => `/brands/${slug}`;
export const collectionPath = (slug) => `/collections/${slug}`;
export const productPath = (slug) => `/product/${slug}`;

/** Best listing URL for a product card's category (keeps the audience when the product has one). */
export const productCategoryPath = (p) => {
  if (!p?.department_slug) return "/new-arrivals";
  const aud = isAudience(p.gender) ? p.gender : null;
  return p.category_slug && p.category_slug !== p.department_slug ? catPath(p.department_slug, p.category_slug, aud) : deptPath(p.department_slug, aud);
};

/** Children of a department that have products for the given audience (or any, when audience is null). */
export const childrenFor = (dept, audience) => (dept?.children || []).filter((c) => (audience ? (c.counts?.[audience] || 0) > 0 : (c.count || 0) > 0));
export const deptCount = (dept, audience) => (audience ? dept?.counts?.[audience] || 0 : dept?.count || 0);
